import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import {
  Box,
  Button,
  Form,
  ModalContext,
  SidebarModal,
  Text,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import useProviderPackage, { useProviderPackageForm } from '@hooks/useProviderPackage'

const DuplicateProviderPackageModal = (props) => {
  const { callbacks, modalKey, showModal } = props
  const { closeModal, duplicateProviderPackage } = callbacks || {}

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const { providerPackage } = digObject(modalData, modalKey, {})

  const providerPackagePayload = useProviderPackage(providerPackage)
  const {
    callbacks: {
      duplicateProviderPackage: duplicateFn,
    },
    creating,
    provider,
  } = providerPackagePayload

  const providerPackageForm = useProviderPackageForm({
    ...providerPackage,
    title: `${providerPackage.title} Copy`,
  })

  const {
    entityState,
    entityState: { title },
    handlers,
    saveEnabled,
  } = providerPackageForm

  const duplicateProviderPackagePayload = {
    callbacks: {
      action: duplicateFn,
      afterAction: closeModal,
    },
    entityParams: entityState,
    shouldRedirect: true,
    toastText: 'Provider Package Duplicated',
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={modalKey} showModal={showModal} size="small">
      <SidebarModal.Header
        callbacks={callbacks}
        title="Duplicate"
        titleSecondLine="Package"
      />

      <SidebarModal.SubHeader boxProps={{ flexDirection: 'column' }}>
        <Text color="mysteryGrey" fontSize="small" width="100%">
          Duplicate Source
        </Text>

        <Box flexDirection="column" marginTop="large">
          <Text color="bodyFontColor" marginBottom="medium">{providerPackage.title}</Text>
          <Text color="mysteryGrey" fontSize="xsmall">{`Package From ${provider.title}`}</Text>
        </Box>
      </SidebarModal.SubHeader>

      <SidebarModal.Content>
        <Form>
          <Form.Field label="New Title">
            <input name="title" type="text" value={title} {...handlers} />
          </Form.Field>
        </Form>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!saveEnabled}
          loading={creating}
          onClick={() => duplicateProviderPackage(duplicateProviderPackagePayload)}
          size="large"
        >
          Duplicate Package
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

DuplicateProviderPackageModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

DuplicateProviderPackageModal.defaultProps = {
  modalKey: 'DuplicateProviderPackageModal',
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <DuplicateProviderPackageModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
